import { Box, Grid, Pagination } from "@mui/material";
import { useState } from "react";
import Thumb from "../../../../../assets/images/DummyThumb.png";
import RecentHuddleCard from "../RecentHuddleCard";

const GroupCallRecordings = ({ groupZoomCalls, isLoading, deleteHandler }: any) => {
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 12;

    const calls = groupZoomCalls || [];

    const sortedGroupZoomCalls = [...calls].sort((a: any, b: any) => {
        const aDate = new Date(a?.start_time)?.getTime();
        const bDate = new Date(b?.start_time)?.getTime();
        return bDate - aDate;
    });

    const totalItems = sortedGroupZoomCalls.length;
    const totalPages = Math.ceil(totalItems / pageSize);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedCalls = sortedGroupZoomCalls.slice(startIndex, startIndex + pageSize);

    const handlePageChange = (_: React.ChangeEvent<unknown>, value: number) => {
        setCurrentPage(value);
    };

    return (
        <Box>
            {!isLoading && sortedGroupZoomCalls.length === 0 && (
                <div className="bg-white w-full my-[3rem] text-center py-12 rounded-lg">
                    <p className="text-4xl sm:text-5xl text-primary_blue">No Recordings Found</p>
                </div>
            )}

            {isLoading ? (
                <div className="bg-white w-full my-[3rem] text-center py-12 rounded-lg">
                    <p className="text-4xl sm:text-5xl text-primary_blue">Loading...</p>
                </div>
            ) : (
                sortedGroupZoomCalls.length > 0 && (
                    <>
                        <Grid container spacing="2rem" marginTop="0rem">
                            {paginatedCalls.map((item: any, index: number) => {
                                const video = item?.recording_files?.find((vid: any) => vid.file_type === "MP4");
                                const url = `${video?.play_url}?pwd=${item?.recording_play_passcode}`;
                                return (
                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                        <RecentHuddleCard
                                            title={item?.topic}
                                            detail={item?.detail || null}
                                            thumbnail={Thumb}
                                            id={item?.id}
                                            item={item}
                                            date={item?.start_time}
                                            type="zoom"
                                            onDelete={deleteHandler}
                                            url={url}
                                            status={video?.status}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>

                        {
                            totalPages > 1 && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        mt: "4rem",
                                        gap: "2rem",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Pagination
                                        count={totalPages}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        color="primary"
                                        size="large"
                                    />
                                </Box>
                            )
                        }
                    </>
                )
            )}
        </Box>
    );
};

export default GroupCallRecordings;
